import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ToolingRoute from "Tooling";
const getRouteObject = store => {
  return {
    path: "regions",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(/* webpackChunkName: "regions" */ "./components"),
      ]).then(([importedModule0]) => {
        const Component = importedModule0.default;
        return Component;
      });
      //.catch(err => {
      // throw err;
      // });
    }),
    childRoutes: [ToolingRoute(store)],
  };
};
export default getRouteObject;
